__webpack_require__.p = "/apps/activity/js/";